import { gql } from '@apollo/client';

export const RESOLVE_INTERVIEW_TOKEN = gql`
  mutation ResolveInterviewToken($token: String!) {
    resolveInterviewToken(token: $token) {
      user {
        _id
        email
        firstName
        lastName
        token
      }
      application {
        _id
        job {
          _id
          title
          hideClientName
        }
        client {
          _id
          company
        }
        stage
      }
    }
  }
`;
